import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateVRFOutdoor } from '../../redux/vrf/vrf_outdoor_actions';

const mapStateToProps = state => ({
  isDuplicating: state.vrfOutdoor.isDuplicating,
  errorMessage: state.vrfOutdoor.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateVRFOutdoor(id, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/VRFOutdoorDuplicateModal.js